//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { IScope } from 'angular';
import React from 'react';
import { useSelector } from 'react-redux';

import { CenteredSpinner } from '@components/atoms/spinner/Spinner';
import makeAngularReactControllerWithScope from '@react-bridge/angular-react-widget-with-scope';
import { getRootCuid } from '@uia/details/selectors/getUIAReactPortItemDetails';
import { UIAContainer } from '@uia/layout/UIAContainer';
import { UIAProducts } from '@uia/products/UIAProducts';
import { getIsUiaReactPortItemProductsEnabled } from '@uia/products/selectors/getUIAReactPortItemProducts';
import { isDefined } from '@utils/filterPredicates';

export interface UniversalImageActionsProductsProps {
  onCloseModal: () => void;
}

const UniversalImageActionsProducts = ({
  onCloseModal,
}: UniversalImageActionsProductsProps) => {
  // TODO: PD-261863 - Remove the feature flag usage once UIA Item Products is complete
  const isUiaReactPortItemProductsEnabled = useSelector(
    getIsUiaReactPortItemProductsEnabled,
  );

  const cuid = useSelector(getRootCuid);

  return (
    <UIAContainer>
      {(() => {
        if (isUiaReactPortItemProductsEnabled) {
          return isDefined(cuid) ? (
            <UIAProducts cuid={cuid} onClose={onCloseModal} />
          ) : (
            <CenteredSpinner />
          );
        } else {
          return <></>;
        }
      })()}
    </UIAContainer>
  );
};

angular.module('curalate').component('uiaProducts', {
  controller: makeAngularReactControllerWithScope((scope: IScope) => {
    return (
      <UniversalImageActionsProducts
        onCloseModal={() => scope.$emit('uia:modal:close')}
      />
    );
  }),
});
